import {
  dismissAllNotifications as sharedDismissAllNotifications,
  dismissNotification as sharedDismissNotification,
  fetchNotifications as sharedFetchNotifications,
} from "@healthos/client-data";
import type { api } from "@healthos/schemas";
import { client } from "./healthos";

export const NOTIFICATIONS_QUERY_KEY = ["notifications"] as const;

export async function fetchNotifications(
  includeDismissed = false,
): Promise<api.NotificationItem[]> {
  return sharedFetchNotifications(client(), includeDismissed);
}

export async function dismissNotification(id: string): Promise<void> {
  await sharedDismissNotification(client(), id);
}

export async function dismissAllNotifications(): Promise<api.DismissAllNotificationsResponse> {
  return sharedDismissAllNotifications(client());
}
